import { useMemo } from 'react';
import { connect } from 'react-redux';

import { DATE_FORMAT_LONG_MINUTE, DATE_FORMAT_LONG_MINUTE_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { ErrorsIcon } from 'KnmPackage/KnmHeaderModule/components/ErrorsIcon';
import {
  getKnmData,
  getKnmHasReasonsImpossibility,
  getKnmStatusText,
  getKnmSystemType,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { KnmSystemTypesEnum } from 'KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import { IKnmState } from 'KnmPackage/MainModule/types/IKnmState';
import { formatDate, getFormatedClientTime } from 'CorePackage/MainModule/common/formatDate';
import { getNewMappedStatus } from 'KnmErpPackage/MainModule/common/getNewMappedStatus';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './KnmInfo.module.scss';
import { getIsSticked } from '../reducers/headerReducer';
import { ErknmStatusHint } from '../../../KnmPackage/KnmHeaderModule/components/ErknmStatusHint';
import { PmStatusHint } from '../../../KnmPackage/KnmHeaderModule/components/PmStatusHint';

interface IKnmInfoProps {
  isKnmSignButtonHover: boolean;
}

interface IKnmInfoStoreProps {
  knmData: NonNullable<IKnmState>['rawData'] | undefined;
  isReasonsImpossibility: boolean;
  statusText: NonNullable<IKnmState>['statusText'] | undefined;
  knmSystemType: KnmSystemTypesEnum | undefined;
  isSticked: boolean;
}

const KnmInfoWithoutStore = ({
  isReasonsImpossibility,
  knmData,
  knmSystemType,
  statusText,
  isSticked,
  isKnmSignButtonHover,
}: IKnmInfoProps & IKnmInfoStoreProps) => {
  const creationDateText = useMemo(
    () =>
      ` от ${
        knmData?.creationDate
          ? formatDate({
              date: knmData.creationDate,
              dateFormat: DATE_FORMAT_LONG_MINUTE,
            })
          : getFormatedClientTime(DATE_FORMAT_LONG_MINUTE_FNS)
      }`,
    [knmData],
  );

  const titleText = useMemo(
    () =>
      knmData && knmData.erpId
        ? `${knmSystemType === KnmSystemTypesEnum.PM ? 'ПМ' : 'КНМ'} ${knmData.erpId}${
            knmData.planId ? ` / ${knmData.planId}` : ''
          } `
        : (knmSystemType === KnmSystemTypesEnum.PM && 'ПМ') || 'КНМ',
    [knmData, knmSystemType],
  );

  const containerAttributes = {
    ...(isSticked && { 'data-visible': true }),
  };

  return (
    <div className={styles.Container} {...containerAttributes}>
      <h3 className={styles.Title}>{titleText}</h3>
      {(!knmData || knmData?.creationDate || !knmData?.erpId) && (
        <small className={styles.Date}>{creationDateText}</small>
      )}
      {statusText && (
        <>
          <span>&nbsp;</span>
          <span className={styles.Status}>
            {knmSystemType === KnmSystemTypesEnum.ERP
              ? getNewMappedStatus(statusText, isReasonsImpossibility)
              : statusText}
          </span>
        </>
      )}
      {knmSystemType === KnmSystemTypesEnum.ERKNM && <ErknmStatusHint isHover={isKnmSignButtonHover} />}
      {knmSystemType === KnmSystemTypesEnum.PM && <PmStatusHint isHover={isKnmSignButtonHover} />}
      <ErrorsIcon className={styles.ErrorsIcon} autoHidingTooltip="onHeaderStickOff" />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IKnmInfoStoreProps => ({
  knmData: getKnmData(state),
  isReasonsImpossibility: getKnmHasReasonsImpossibility(state),
  statusText: getKnmStatusText(state),
  knmSystemType: getKnmSystemType(state),
  isSticked: getIsSticked(state),
});

export const KnmInfo = connect(mapStateToProps)(KnmInfoWithoutStore);
